import { render, staticRenderFns } from "./expoOrderList.vue?vue&type=template&id=651ecbb8&scoped=true"
import script from "./expoOrderList.vue?vue&type=script&lang=js"
export * from "./expoOrderList.vue?vue&type=script&lang=js"
import style0 from "./expoOrderList.vue?vue&type=style&index=0&id=651ecbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ecbb8",
  null
  
)

export default component.exports